// extracted by mini-css-extract-plugin
export var aircallIframe = "_gs-3";
export var fabContainer = "_gs-5";
export var fabRinging = "_gs-6";
export var loadingOverlay = "_gs-4";
export var pulse = "_gs-7";
export var widgetContent = "_gs-2";
export var widgetPanel = "_gs-0";
export var widgetPanelExpanded = "_gs-1";